import { render, staticRenderFns } from "./tranPurOrders.vue?vue&type=template&id=b28fbcf8&scoped=true&"
import script from "./tranPurOrders.vue?vue&type=script&lang=js&"
export * from "./tranPurOrders.vue?vue&type=script&lang=js&"
import style0 from "./tranPurOrders.vue?vue&type=style&index=0&id=b28fbcf8&lang=less&scoped=true&"
import style1 from "./tranPurOrders.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28fbcf8",
  null
  
)

component.options.__file = "tranPurOrders.vue"
export default component.exports